import { render, staticRenderFns } from "./ServicejobView.vue?vue&type=template&id=061b9ee6&scoped=true"
import script from "./ServicejobView.vue?vue&type=script&lang=js"
export * from "./ServicejobView.vue?vue&type=script&lang=js"
import style0 from "./ServicejobView.vue?vue&type=style&index=0&id=061b9ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b9ee6",
  null
  
)

export default component.exports